export const Uk16 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.41756 8.01843C2.81266 14.3547 8.10183 21.0526 13.4759 22.1679C3.0547 22.8637 -1.17555 12.1097 4.02468 5.93078C11.0526 -2.41977 22.2008 3.61115 22.2008 8.94627C20.524 5.23487 11.2949 2.68332 7.41756 8.01843Z"
      fill="#878787"
    />
    <path
      d="M21.7576 13.5782C21.7576 17.1631 18.7132 20.0691 14.9576 20.0691C11.2021 20.0691 8.15764 17.1631 8.15764 13.5782C8.15764 9.9934 11.2021 7.08733 14.9576 7.08733C18.7132 7.08733 21.7576 9.9934 21.7576 13.5782Z"
      fill="#1677D2"
    />
  </svg>
);
